"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pool = void 0;

var Pool =
/** @class */
function () {
  function Pool(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.GetPool = function (poolId) {
    return this.restClient.get('Pool/UseCase/GetPool', {
      poolId: poolId
    });
  };
  /**
   * @param string - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.GetPoolContract = function (poolId) {
    return this.restClient.get('Pool/UseCase/GetPoolContract', {
      poolId: poolId
    });
  };
  /**
   * @param string - userId
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-500
   * @param string? - sortBy
   * @param string? - sortDirection ascending|descending
   * @return Promise|Observable|any
   */


  Pool.prototype.ListAccessiblePoolsForUser = function (userId, page, itemsPerPage, sortBy, sortDirection) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    return this.restClient.get('Pool/UseCase/ListAccessiblePoolsForUser', {
      userId: userId,
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  };
  /**
   * @param string - poolId
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  Pool.prototype.ListPoolAllotmentsForPool = function (poolId, sortBy, sortDirection, page, itemsPerPage) {
    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('Pool/UseCase/ListPoolAllotmentsForPool', {
      poolId: poolId,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param string - poolId
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-500
   * @param string[]? - withData
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @return Promise|Observable|any
   */


  Pool.prototype.ListPoolContactsByPoolId = function (poolId, page, itemsPerPage, withData, sortBy, sortDirection) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (withData === void 0) {
      withData = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    return this.restClient.get('Pool/UseCase/ListPoolContactsByPoolId', {
      poolId: poolId,
      page: page,
      itemsPerPage: itemsPerPage,
      withData: withData,
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  };
  /**
   * @param string? - name
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @param boolean? - shouldHideDeleted true|false
   * @return Promise|Observable|any
   */


  Pool.prototype.ListPools = function (name, sortBy, sortDirection, page, itemsPerPage, shouldHideDeleted) {
    if (name === void 0) {
      name = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (shouldHideDeleted === void 0) {
      shouldHideDeleted = null;
    }

    return this.restClient.get('Pool/UseCase/ListPools', {
      name: name,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage,
      shouldHideDeleted: shouldHideDeleted
    });
  };
  /**
   * @param string - poolId
   * @param string? - sortBy name|slug
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-500
   * @return Promise|Observable|any
   */


  Pool.prototype.ListTagsForPool = function (poolId, sortBy, sortDirection, page, itemsPerPage) {
    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('Pool/UseCase/ListTagsForPool', {
      poolId: poolId,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param string - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.ListUniqueTagNamesForPool = function (poolId) {
    return this.restClient.get('Pool/UseCase/ListUniqueTagNamesForPool', {
      poolId: poolId
    });
  }; // Commands

  /**
   * @param string - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.ArchivePool = function (poolId) {
    return this.restClient.post('Pool/UseCase/ArchivePool', {
      poolId: poolId
    });
  };
  /**
   * @param string - name
   * @param string? - shortName
   * @param string? - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.CreatePool = function (name, shortName, poolId) {
    if (shortName === void 0) {
      shortName = null;
    }

    if (poolId === void 0) {
      poolId = null;
    }

    return this.restClient.post('Pool/UseCase/CreatePool', {
      name: name,
      shortName: shortName,
      poolId: poolId
    });
  };
  /**
   * @param string - poolId
   * @param string - poolContractType cio|intro|trial|pro|premier|premierPlus|custom|internal
   * @param number - startDate
   * @param number - endDate
   * @param string? - poolContractId
   * @return Promise|Observable|any
   */


  Pool.prototype.CreatePoolContract = function (poolId, poolContractType, startDate, endDate, poolContractId) {
    if (poolContractId === void 0) {
      poolContractId = null;
    }

    return this.restClient.post('Pool/UseCase/CreatePoolContract', {
      poolId: poolId,
      poolContractType: poolContractType,
      startDate: startDate,
      endDate: endDate,
      poolContractId: poolContractId
    });
  };
  /**
   * @param string - poolId
   * @param string - poolWebhookType
   * @param string - url
   * @return Promise|Observable|any
   */


  Pool.prototype.CreatePoolWebhook = function (poolId, poolWebhookType, url) {
    return this.restClient.post('Pool/UseCase/CreatePoolWebhook', {
      poolId: poolId,
      poolWebhookType: poolWebhookType,
      url: url
    });
  };
  /**
   * @param string - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.DeletePool = function (poolId) {
    return this.restClient.post('Pool/UseCase/DeletePool', {
      poolId: poolId
    });
  };
  /**
   * @param string - userId
   * @param string - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.RemoveAllUserRolesFromPool = function (userId, poolId) {
    return this.restClient.post('Pool/UseCase/RemoveAllUserRolesFromPool', {
      userId: userId,
      poolId: poolId
    });
  };
  /**
   * @param string - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.RemoveCustomerDisplayNameForPool = function (poolId) {
    return this.restClient.post('Pool/UseCase/RemoveCustomerDisplayNameForPool', {
      poolId: poolId
    });
  };
  /**
   * @param string - poolId
   * @return Promise|Observable|any
   */


  Pool.prototype.RemovePrivacyPolicyLinkForPool = function (poolId) {
    return this.restClient.post('Pool/UseCase/RemovePrivacyPolicyLinkForPool', {
      poolId: poolId
    });
  };
  /**
   * @param string - poolId
   * @param string - userId
   * @param string? - slackUserId
   * @param any[]? - requestedFeatureSlugs
   * @param string? - other
   * @return Promise|Observable|any
   */


  Pool.prototype.SendUpgradeRequestToCsm = function (poolId, userId, slackUserId, requestedFeatureSlugs, other) {
    if (slackUserId === void 0) {
      slackUserId = null;
    }

    if (requestedFeatureSlugs === void 0) {
      requestedFeatureSlugs = null;
    }

    if (other === void 0) {
      other = null;
    }

    return this.restClient.post('Pool/UseCase/SendUpgradeRequestToCsm', {
      poolId: poolId,
      userId: userId,
      slackUserId: slackUserId,
      requestedFeatureSlugs: requestedFeatureSlugs,
      other: other
    });
  };
  /**
   * @param string - poolId
   * @param string - customerDisplayName
   * @return Promise|Observable|any
   */


  Pool.prototype.SetCustomerDisplayNameForPool = function (poolId, customerDisplayName) {
    return this.restClient.post('Pool/UseCase/SetCustomerDisplayNameForPool', {
      poolId: poolId,
      customerDisplayName: customerDisplayName
    });
  };
  /**
   * @param string - poolId
   * @param string - name
   * @return Promise|Observable|any
   */


  Pool.prototype.SetNameForPool = function (poolId, name) {
    return this.restClient.post('Pool/UseCase/SetNameForPool', {
      poolId: poolId,
      name: name
    });
  };
  /**
   * @param string - poolId
   * @param string - privacyPolicyLink
   * @return Promise|Observable|any
   */


  Pool.prototype.SetPrivacyPolicyLinkForPool = function (poolId, privacyPolicyLink) {
    return this.restClient.post('Pool/UseCase/SetPrivacyPolicyLinkForPool', {
      poolId: poolId,
      privacyPolicyLink: privacyPolicyLink
    });
  };
  /**
   * @param string - poolId
   * @param string - shortName
   * @return Promise|Observable|any
   */


  Pool.prototype.SetShortNameForPool = function (poolId, shortName) {
    return this.restClient.post('Pool/UseCase/SetShortNameForPool', {
      poolId: poolId,
      shortName: shortName
    });
  };
  /**
   * @param string - poolContractId
   * @param string? - poolContractType cio|intro|trial|pro|premier|premierPlus|custom|internal
   * @param number? - startDate
   * @param number? - endDate
   * @return Promise|Observable|any
   */


  Pool.prototype.UpdatePoolContract = function (poolContractId, poolContractType, startDate, endDate) {
    if (poolContractType === void 0) {
      poolContractType = null;
    }

    if (startDate === void 0) {
      startDate = null;
    }

    if (endDate === void 0) {
      endDate = null;
    }

    return this.restClient.post('Pool/UseCase/UpdatePoolContract', {
      poolContractId: poolContractId,
      poolContractType: poolContractType,
      startDate: startDate,
      endDate: endDate
    });
  };

  return Pool;
}();

exports.Pool = Pool;